import React from "react";

const LoadingErrorMsg = () => {
  return (
    <div className="loadingError">
      Sorry, An Error Occured while loading your page
    </div>
  );
};

export default LoadingErrorMsg;
